<template>
  <div :class="$style.screen" @click.self="$emit('screen-click')">
    <div :class="$style.buttons" class="ui container">
      <div :class="$style.contentWidth">
        <search-type-buttons
          :type="type"
          :in-screen="true"
          @change="changeType"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchTypeButtons from '@/components/SearchTypeButtons.vue'

export default {
  components: {
    SearchTypeButtons
  },
  props: {
    type: {
      type: String,
      default: 'book'
    }
  },
  methods: {
    changeType (type) {
      this.$emit('change', type)
    }
  }
}
</script>

<style module>
@value contentWidth from '~@/stylesheets/app.css';

.screen {
  composes: screen from "~@/stylesheets/modal.css";
  z-index: 100;
}

.buttons {
  composes: padder from "~@/stylesheets/app.css";
  margin-top: 50px;
}
</style>
